import type { Getter, Setter } from 'jotai';
import type { OutputRelationshipT } from '../../../../../modernization-common/relationships';
import type { UndoRedoActionCommand } from '../../../../../modernization-common/undo-redo/types';
import { relationshipStoreAtom } from '../../relationship-atoms';
import type { SaveRelationshipsEventPayload } from '../events';
export const saveRelationshipsCommandFactory = (get: Getter, set: Setter): UndoRedoActionCommand<SaveRelationshipsEventPayload, void> => {
  // undefined means the relationship did not exist before (create mode)
  let previousRelationships: Record<string, OutputRelationshipT | undefined> = {};
  return {
    execute: payload => {
      previousRelationships = {};
      const store = get(relationshipStoreAtom);
      for (const rel of payload.relationships) {
        previousRelationships[rel.id] = store[rel.id];
      }
      set(relationshipStoreAtom, prev => {
        const next = {
          ...prev
        };
        for (const rel of payload.relationships) {
          next[rel.id] = {
            id: rel.id,
            labelName: rel.relationshipLabel.relationshipLabelName,
            sourceAnnotationId: rel.sourceAnnotationId,
            targetAnnotationId: rel.targetAnnotationId,
            frameRanges: rel.frameRanges
          };
        }
        return next;
      });
    },
    undo: payload => {
      set(relationshipStoreAtom, prev => {
        const next = {
          ...prev
        };
        for (const rel of payload.relationships) {
          const previous = previousRelationships[rel.id];
          if (previous === undefined) {
            delete next[rel.id]; // Was a create — remove it
          } else {
            next[rel.id] = previous; // Was an edit — restore original
          }
        }
        return next;
      });
    }
  };
};